import { useState } from 'react';

export default (toggled) => {
  const [isToggled, setIsToggled] = useState(toggled);

  return [isToggled, () => { setIsToggled(!isToggled); }];
};
